import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UntypedFormGroup } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { PowerplatformAgentActionAuthenticationMode } from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';

@Component({
  selector: 'app-set-authentication-mode',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatRadioModule, LabelsProviderPipe],
  templateUrl: './set-authentication-mode.component.html',
  styleUrl: './set-authentication-mode.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetAuthenticationModeComponent {
  public fg = input.required<UntypedFormGroup>();
  public playbooksActionInput = input.required<PlaybooksActionDefinitionInput>();
  public triggerType = input.required<TriggerTypes>();
  public authenticationMode = model<PowerplatformAgentActionAuthenticationMode>(
    PowerplatformAgentActionAuthenticationMode.invoker
  );

  public readonly authenticationModeEnum = PowerplatformAgentActionAuthenticationMode;

  public onRadioButtonChange(value: PowerplatformAgentActionAuthenticationMode): void {
    this.authenticationMode.set(value);
  }
}
